export const environment = {
  production: true,
  buildId: '2836347244019441',
  configFile: 'config.json',
};
